<template>
  <div class="card shadow-sm rounded-3 overflow-hidden p-4">
    <!-- Skeleton while loading -->
    <ul v-if="isLoading" class="timeline list-unstyled m-0">
      <li v-for="n in 4" :key="n" class="d-flex position-relative mb-4">
        <div class="me-3 d-flex flex-column align-items-center">
          <span class="timeline-dot skeleton"></span>
          <span class="timeline-line flex-grow-1 skeleton"></span>
        </div>
        <div class="flex-grow-1">
          <div class="skeleton skeleton-text w-25 mb-2"></div>
          <div class="skeleton skeleton-text w-50 mb-1"></div>
          <div class="skeleton skeleton-text w-75"></div>
        </div>
      </li>
    </ul>

    <!-- History list -->
    <ul v-else-if="history.length > 0" class="timeline list-unstyled m-0">
      <li
        v-for="(item, index) in history"
        :key="index"
        class="d-flex position-relative mb-4"
      >
        <!-- Circle -->
        <div class="me-3 d-flex flex-column align-items-center">
          <span class="timeline-dot"></span>
          <span
            v-if="index !== history.length - 1"
            class="timeline-line flex-grow-1"
          ></span>
        </div>

        <!-- Content -->
        <div>
          <small class="text-muted d-block mb-1">{{
            formatDate(item.created_at)
          }}</small>
          <div class="fw-bold">{{ item.activity }}</div>
          <div v-if="item.description" class="text-muted small">
            <div v-for="(line, i) in item.description" :key="i">{{ line }}</div>
          </div>
        </div>
      </li>
    </ul>

    <!-- Empty state -->
    <div v-else class="text-muted text-center py-3">No history available</div>
  </div>
</template>

<script setup>
defineProps({
  history: {
    type: Array,
    default: () => [],
  },
  isLoading: {
    type: Boolean,
    default: false,
  },
});

function formatDate(dateString) {
  const date = new Date(dateString);

  const day = String(date.getDate()).padStart(2, "0");
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const year = String(date.getFullYear()).slice(-2);

  const hours = String(date.getHours()).padStart(2, "0");
  const minutes = String(date.getMinutes()).padStart(2, "0");

  return `${day}/${month}/${year}, ${hours}:${minutes}`;
}
</script>

<style scoped>
.timeline-dot {
  width: 10px;
  height: 10px;
  border: 2px solid #999;
  border-radius: 50%;
  background: #fff;
  margin-top: 4px;
}
.timeline-line {
  width: 2px;
  background: #ddd;
  flex-grow: 1;
  margin-top: 2px;
}

/* Skeleton styles */
.skeleton {
  background: linear-gradient(90deg, #e0e0e0 25%, #f5f5f5 50%, #e0e0e0 75%);
  background-size: 200% 100%;
  animation: shimmer 1.5s infinite;
  border-radius: 4px;
}
.skeleton-text {
  height: 14px;
}
@keyframes shimmer {
  0% {
    background-position: -200% 0;
  }
  100% {
    background-position: 200% 0;
  }
}
</style>
